/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Component, Input, OnInit } from '@angular/core';
import { EnvironmentService } from '@commonspirit/ngx-environment';
import { InstanceService } from '@commonspirit/ngx-instance';
import { getEmbedSource } from 'src/app/core/util/root-element';
import { navigateFAD } from '../../models/v2/search';
import { ActivatedRoute } from '@angular/router';
import { ConfigurationKey } from 'src/app/core/models/configuration-key';

@Component({
  selector: 'fal-fad-components',
  templateUrl: './fad-components.component.html',
  styleUrls: ['./fad-components.component.scss']
})
export class FadComponentsComponent implements OnInit {
  @Input() navigateProviderFAD: navigateFAD;

  public createScript = document.createElement('script');
  configurationUrl: string | undefined;

  providerNPI = '';
  currentRoute = '';
  embedSource: string | undefined | null;
  baseUrl = '/fad/';

  constructor(public service: InstanceService, private environmentService: EnvironmentService, private route: ActivatedRoute) {
    // Get Configuration URL
    this.configurationUrl = this.environmentService.getEndpoint('fadConfigurationUrl')?.url;
    this.embedSource = getEmbedSource();
  }

  ngOnInit(): void {
    if (this.navigateProviderFAD && window.location.pathname != sessionStorage.getItem('providerPreviousPath')) {
      sessionStorage.setItem('providerPreviousPath', window.location.pathname);
      this.currentRoute = window.location.pathname;
    } else if (sessionStorage.getItem('providerPreviousPath')) {
      this.currentRoute = sessionStorage.getItem('providerPreviousPath') ?? '';
    }
    window.sessionStorage.setItem('FAL_Provider_redirectto-fad', 'true');
    window.sessionStorage.setItem('falLocationDetailsParam', 'true');

    if (location.hostname?.includes('vmfh')) {
      const falPageUrl = this.service.getConfiguration(ConfigurationKey.FalPage)?.value as { link: string };
      this.baseUrl = `/${falPageUrl.link}/fad/`;
    } else if (location.pathname?.includes('/examples/vmfh/')) {
      this.baseUrl = '/examples/vmfh/fad/';
    } else if (location.pathname?.includes('/pagelet/vmfh/')) {
      this.baseUrl = '/pagelet/vmfh/fad/';
    } else {
      this.baseUrl = '/fad/';
    }

    const providerSulg = this.route.snapshot.paramMap.get('providerSlug');
    if (providerSulg) {
      this.providerDetails(providerSulg);
    } else if (this.navigateProviderFAD && this.navigateProviderFAD.npi) {
      this.providerDetails(this.navigateProviderFAD.npi);
    }
  }

  providerDetails(npi: string): void {
    this.providerNPI = npi;
    const fadSaasjs = this.environmentService.getEndpoint('fadSaasjs')?.url;
    this.LoadScripts(fadSaasjs ? fadSaasjs : '');
  }

  LoadScripts(scriptSrc: string): void {
    const containFADScript = document.getElementsByTagName('head')[0].getElementsByTagName('script');
    let containsScript = false;
    for (let index = 0; index < containFADScript.length; index++) {
      if (containFADScript[index].src === scriptSrc) {
        containsScript = true;
      }
    }

    if (!containsScript) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      const script = this.createScript;
      script.type = 'text/javascript';
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      script.src = scriptSrc;
      document.getElementsByTagName('head')[0].appendChild(script);
    }

    if (!window.sessionStorage.getItem('FALredirecttoFAD')) {
      window.sessionStorage.setItem('FALredirecttoFAD', 'true');
    }
  }
}
